import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IonRefresher, LoadingController, NavController} from '@ionic/angular';
import {select, Store} from '@ngrx/store';
import {Observable, Subject} from 'rxjs';
import * as actionsUi from './aufgaben-berechtigungen-home.actions.ui';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {SafeUrl} from '@angular/platform-browser';
import { Settings, SettingsProvider } from '@orga-app/settings';
import {getFunktionsbereiche, getFunktionsbereicheFehler, getFunktionsbereicheLaden} from './aufgaben-berechtigungen-home.selectors';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {Funktionsbereich} from '../../../../clients/vorlagen';
import {takeUntil, takeWhile} from 'rxjs/operators';
import { NotificationService } from '@orga-app/providers/notification.service';
import { DocumentService } from '@orga-app/providers/document.service';

@Component({
    selector: 'app-aufgaben-berechtigungen',
    templateUrl: './aufgaben-berechtigungen-home.page.html',
})
export class AufgabenBerechtigungenHomePage implements OnInit, OnDestroy {
    @ViewChild(IonRefresher, { static: false})
    public settings$: Observable<Settings>;
    public themeDefault$: Observable<Settings>;
    public logoHeaderSVG$: Observable<SafeUrl>;
    private aiName = 'AufgabenBerechtigungenHomePage';

    public funktionsbereiche$: Observable<Array<ListInputItem>>;
    public funktionsbereicheLaden$: Observable<boolean>;
    public funktionsbereicheFehler$: Observable<boolean>;

    public selectedFunktionsbereichId: string;

    private unsubscribe$ = new Subject();
    public alive = true;

    constructor(public navCtrl: NavController,
                private store: Store<any>,
                private settingsProvider: SettingsProvider,
                public route: ActivatedRoute,
                public router: Router,
                public loadingCtrl: LoadingController,
                private notificationService: NotificationService,
                private documentService: DocumentService,
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();


        this.funktionsbereiche$ = this.store.pipe(select(getFunktionsbereiche));
        this.funktionsbereicheLaden$ = this.store.pipe(select(getFunktionsbereicheLaden));
        this.funktionsbereicheFehler$ = this.store.pipe(select(getFunktionsbereicheFehler));

        this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (this.route.snapshot.firstChild !== undefined && this.route.snapshot.firstChild !== null) {
                    const a = this.route.snapshot.firstChild.params;
                    this.selectedFunktionsbereichId = (a['funktionsbereichId'] === 'null' || a['funktionsbereichId'] === undefined) ? null : a['funktionsbereichId'];
                }
            }
        });
    }

    ngOnInit() {
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
        await this.ladeDaten();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.complete();
    }

    async ladeDaten() {
        this.store.dispatch(new actionsUi.PageLoadDataAction());
    }

    funktionsbereichLaden(fb: Funktionsbereich) {
        this.selectedFunktionsbereichId = fb.funktionsbereich_id;
        this.router.navigateByUrl('aufgaben-berechtigungen/' + fb.funktionsbereich_id + '/checklisten');
    }

    async downloadExcel() {
      const loading = await this.loadingCtrl.create({
          spinner: 'dots',
          message: 'Exceldownload für Funktionsbereiche wird geladen'
      });
      await loading.present();

      const url = '/api/query/vorlagen/reporting/aufgaben-berechtigungen-benutzer/excel';
      this.documentService.getDocument(url, {}).pipe(takeWhile(() => this.alive)).pipe(takeUntil(this.unsubscribe$))
          .subscribe(async (document) => {
                  if (document != null) {
                      // console.log('loaded');
                      await loading.dismiss();

                      const date = new Date();
                      const month: number = <number>date.getMonth() + 1;
                      this.documentService.saveFile(document, 'Funktionsbereiche-Aufgaben-Berechtigungen' + date.getFullYear() + '-' + month + '-' + date.getDate());
                  }
              },
              error => {
                  this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                  loading.dismiss();
              }, () => {
              });
  }
}
